<!--  -->
<template>
    <div class="box">
        <div class="video">
            <video :src="downloadURLImg+'6b7bd63fef18153eac76cfd8ebc6d31f_222187393_mp4'" controls></video>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        mounted() {},
    };
</script>
<style lang='less' scoped>
    // .video {
    //     width: 1200px;
    //     margin: 0 auto;

    //     video {
    //         width: 100%;
    //         height: 400px;
    //     }
    // }

    .box {
        width: 1200px;
        margin: 20px auto 0;

        .video {
            display: flex;
            align-items: center;
            justify-content: space-around;
            border-radius: 10px;
            box-sizing: border-box;

            video {
                width: 1026px;
            }
        }
    }
</style>